export default "__VITE_ASSET__BJHi63ZK__"